import { VideoLayout, WebinarStatus } from '@core/types';
import { useAppSelector } from '@online-webinar/store';
import { RefObject, useEffect, useRef, useState } from 'react';
import { useFullscreenController } from '../../../hooks/useFullscreenController';
import { VindralPlayer } from '../../atoms/VindralPlayer';
import { AppreciationPopup } from './..';

interface Props {
    isActive: boolean;
    isLandscape: boolean;
    isMobile: boolean;
}

export const VideoStreaming = ({ isActive, isLandscape, isMobile }: Props) => {
    const webinarStatus = useAppSelector((state) => state.liveWebinar.webinarData.status);
    const videoLayout = useAppSelector((state) => state.liveWebinar.videoLayout);

    const videoContainerRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement | null>(null);

    const { toggleFullscreen, isFauxFullscreen, isFullscreen } = useFullscreenController(videoContainerRef);

    const [layoutSpecificClasses, setLayoutSpecificClasses] = useState('');
    useEffect(() => {
        let classes = '';
        if (isMobile && isLandscape) {
            classes = 'z-0';
        }
        if (!isMobile) {
            switch (videoLayout) {
                case VideoLayout.VideoOnly:
                case VideoLayout.PresentationWithVideoLarge:
                case VideoLayout.DesktopSharing:
                    classes = 'row-end-3 max-h-[calc(100dvh-var(--viewer-info-space))] bg-black';
                    break;
                case VideoLayout.PresentationWithVideoSmall:
                    classes = 'w-1/4 min-w-48 self-end justify-self-end aspect-video m-4 z-1';
                    break;
                default:
                    classes = 'max-h-[calc(50dvh-calc(var(--viewer-info-space)/2))]';
            }
        }
        setLayoutSpecificClasses(classes);
    }, [isMobile, isLandscape, videoLayout]);

    return (
        <>
            <div className={`col-start-1 row-start-1 ${layoutSpecificClasses} min-h-0`}>
                <svg
                    width="1920"
                    height="1080"
                    viewBox="0 0 1920 1080"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-auto max-w-full ${isMobile ? (isLandscape ? 'max-h-full' : 'max-h-96') : 'max-h-full'}`}
                    fill="transparent"
                >
                    <rect width="1920" height="1080" />
                </svg>
            </div>
            <div
                id="video"
                ref={videoContainerRef}
                className={`${isFauxFullscreen ? 'fixed inset-0 bg-black z-50' : 'relative'} col-start-1 row-start-1 ${layoutSpecificClasses} flex overflow-hidden ${isActive ? '' : 'hidden'}`}
            >
                <div
                    className={`relative max-w-full min-w-0 min-h-0 aspect-video ${isMobile && !isFauxFullscreen ? (isLandscape ? 'w-full max-h-full' : 'h-full max-h-96') : 'h-full max-h-full'} flex m-auto`}
                >
                    {webinarStatus !== WebinarStatus.Planned && webinarStatus !== WebinarStatus.Started ? (
                        <AppreciationPopup isOnDemand={false} />
                    ) : (
                        <VindralPlayer isFullscreen={isFullscreen} isFauxFullscreen={isFauxFullscreen} toggleFullscreen={toggleFullscreen} />
                    )}
                </div>
            </div>
        </>
    );
};
